<template>
    <div>
        <div class="main-nav">
            <header class="nav-header scr-header ">
                <button @click="openOrCloseNav()" class="btn-icon">
                    <i class="icon-close-thin"></i>
                </button>
                <span class="hd-title">Menu</span>
            </header>
            <nav>
                <ul>
                    <li v-for="navItem in UACnavItems" :key="navItem.name">
                        <router-link :to="navItem.page" @click.native="openOrCloseNav()">
                            <i :class="navItem.icon">
                                <span v-if="navItem.name === 'Schedule'">{{currentDay}}</span>
                            </i>
                            {{navItem.name}}
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="menu-overlay"></div>
    </div>
</template>

<script>
import moment from "moment";
import navigationItems from "../store/navUac.json";
//This component contains the navigation side panel.
export default {
    name: "Navigation",
    data() {
        return {
            navigationItems: navigationItems
        };
    },
    props: {
        // This is the user access level for the current user.
        uacLevel: {
            type: Number,
            default: 0
        }
    },
    methods: {
        openOrCloseNav() {
            //Fired when the navigation panel is opened.
            this.$emit("navigation");
        }
    },
    computed: {
        currentDay() {
            return moment().format("DD");
        },
        UACnavItems() {
            let currentNavItems = [];
            this.navigationItems.navItems.forEach(item => {
                if (item.uacLevel <= this.uacLevel) {
                    currentNavItems.push(item);
                }
            });
            currentNavItems.sort((a, b) => {
                if (a.priority > b.priority) {
                    return 1;
                }
                if (b.priority > a.priority) {
                    return -1;
                }
                return 0;
            });
            return currentNavItems;
        }
    }
};
</script>

<style>
</style>
